import { Injectable, computed, inject, signal } from '@angular/core';
import { WorkflowDraftConfirmationService } from '../workflow-registry-diagnostics/workflow-draft-confirmation.service';

/** Navigation protection only; proposed wording remains owned by the mounted editor. */
@Injectable({ providedIn: 'root' })
export class TerminologyEditorStateService {
  private readonly confirmation = inject(WorkflowDraftConfirmationService);
  readonly dirty = signal(false);
  readonly busy = signal(false);
  readonly isNavigationBlocked = computed(() => this.dirty() || this.busy());

  update(state: { dirty: boolean; busy: boolean }): void {
    this.dirty.set(state.dirty);
    this.busy.set(state.busy);
  }

  clear(): void {
    this.update({ dirty: false, busy: false });
  }

  confirmNavigation(): boolean | Promise<boolean> {
    if (this.busy()) return false;
    if (!this.dirty()) return true;
    return this.confirmation.confirm({
      heading: 'Leave terminology edits?',
      message: 'Unsaved wording and change notes will be lost.',
      confirmText: 'Leave without saving',
      cancelText: 'Keep editing',
    });
  }
}
